import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';
import { SignContractModal } from './';
import { contractTypeT } from '../enums';

const baseWeb = process.env.REACT_APP_WEB_URL

@translate()
export default class SignLoanModal extends Component {
  static propTypes = {
    modalActions: PropTypes.object.isRequired,
    onSubmit: PropTypes.func.isRequired,
    isLoading: PropTypes.bool.isRequired,
    fileLocation: PropTypes.string.isRequired,
    t: PropTypes.func.isRequired,
    withInsurance: PropTypes.bool.isRequired,
    insuranceFileLocation: PropTypes.string,
  };

  render() {
    const {
      onSubmit,
      isLoading,
      modalActions,
      fileLocation,
      t,
      withInsurance,
      insuranceFileLocation
    } = this.props;

    let modalText = t(
      'Dlžník sa oboznámil so znením Záväznej žiadosti o pôžičku (zmluva medzi Vami a prevádzkovateľom portálu Majak.sk, spoločnosť Peer2Peer, s.r.o.), rozumie jej, súhlasí s jej znením a berie na vedomie všetky jej účinky ako aj všetky práva a povinnosti z nej vyplývajúce. Je si vedomý, že kliknutím na tlačidlo “Potvrdiť Záväznú žiadosť o pôžičku” je táto zmluva pre dlžníka v celom svojom rozsahu záväzná.'
    )
    let checkBoxText = t('Súhlasím so Záväznou žiadosťou o pôžičku')
    let buttonText = t('Potvrdiť Záväznú žiadosť o pôžičku')

    if (withInsurance) {
      modalText += t(' Dlžník zároveň potvrdzuje, že sa oboznámil s informáciami o poistení schopnosti splácať pôžičku, prečítal si všetky potrebné dokumenty k poisteniu, ktoré sa nachádzajú na: ');
      let finalText = t('a súhlasí so Žiadosťou o zabezpečenie poistenia schopnosti splácať pôžičku.');

      modalText = (<span>{modalText} <a href={`${baseWeb}/na-stiahnutie`} target='blank'>majak.sk/na-stiahnutie</a> {finalText}</span>);

      checkBoxText += t(' a so Žiadosťou o zabezpečenie poistenia')
      buttonText += t(' a Žiadosť o zabezpečenie poistenia')
    }

    return (
      <SignContractModal
        hideModal={modalActions.hide}
        isLoading={isLoading}
        onSubmit={onSubmit}
        fileLocation={fileLocation}
        insuranceFileLocation={insuranceFileLocation}
        title={contractTypeT.MANDATE_DEBTOR}
        text={modalText}
        checkboxText={checkBoxText}
        buttonText={buttonText}
        fileLinktext={t('Prečítať Záväznú žiadosť o pôžičku')}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/common/modals/SignLoanModal.js